import { Stack } from "@mui/material";
import { Button } from "components/UI";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const StructureDetailFormFooter = memo(
  ({
    isCreatedByUser,
    structureMutation,
    structureDeleteMutation,
    reset,
    defaultValues,
    navigate
  }) => {
    const { t } = useTranslation();

    if (!isCreatedByUser) {
      return null;
    }

    return (
      <Stack direction="row" spacing={2} justifyContent="flex-end">
        <Button
          flavor="outlined"
          onClick={() => {
            reset({ ...defaultValues });
            navigate(-1);
          }}
          disabled={
            structureMutation.isLoading || structureDeleteMutation.isLoading
          }
        >
          {t("form.common.cancel")}
        </Button>
        <Button
          type="submit"
          disabled={
            structureMutation.isLoading || structureDeleteMutation.isLoading
          }
        >
          {t("form.common.submit")}
        </Button>
      </Stack>
    );
  }
);

StructureDetailFormFooter.displayName = "StructureDetailFormFooter";

export default StructureDetailFormFooter;
